
import { set, lensPath, equals } from 'ramda';
import * as types from './types';
import { JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { PromotionSettingsService } from '../../services/promotion-settings.service';
import { MODIFICATION_URL, SETTINGS_URL } from '../../../../services/common-urls';
import { random, generateNextId, isNegative } from '../../../../utility/fp';
import { LABEL_URL } from '../../../accounting/services/costs.service';

// Action Object for LabelSettings. Import the types from label/types.js and Invoke Actions from the Vuex Host Components.

export const promotionSettingsActions = {
  async [types.PromotionSettingsData.FETCH.ALL]({ commit }, payload) {

    let data=await PromotionSettingsService.findPromotionSettings()
    console.log("Promo",data);
     commit(types.PromotionSettingsData.SET.ALL, data.data);
  },

  async [types.ResultTypes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("GP",getters.promotionSettingsData.result_types)
    commit(types.PromotionSettingsData.SET.ALL, {

     

      ...getters.promotionSettingsData,
      result_types: [
        {
          result_type_id: generateNextId(getters.promotionSettingsData.result_types.map(e => +e.result_type_id)),
          result_type: '',
        },
        ...getters.promotionSettingsData.result_types,
      ]
    });
  },

  async [types.ResultTypes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log(payload)
    const { name, value, item } = payload;
    const { result_type_id } = item;

    if (isNegative(item.result_type_id)) {

      const insertedResultType = await  PromotionSettingsService.insertResultType(value)
      const new_result_type_id = insertedResultType.data.result_type_id;

      commit(types.PromotionSettingsData.SET.ALL, {
        ...getters.promotionSettingsData,
        result_types: getters.promotionSettingsData.result_types.map(m => {
          if (m.result_type_id == result_type_id) {
            return {
              ...m,
              result_type_id: new_result_type_id,
              result_type: value,
            };
          } else {
            return m;
          }
        })
      });
    } else {
      commit(types.PromotionSettingsData.SET.ALL, {
        ...getters.promotionSettingsData,
        result_types: getters.promotionSettingsData.result_types.map(m => {
          if (m.result_type_id == result_type_id) {
            return {
              ...m,
              result_type: value,
            };
          } else {
            return m;
          }
        })
      });
      const updatedResultType = await PromotionSettingsService.updateResultType(result_type_id,value)
    }
  },
  async [types.ResultTypes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { item } = payload;
    const { result_type_id } = item;
    
    commit(types.PromotionSettingsData.SET.ALL, {
      ...getters.promotionSettingsData,
      result_types: getters.promotionSettingsData.result_types.filter(m => {
        return m.result_type_id != result_type_id
      })
    });
    
    if (!isNegative(item.result_type_id)) {
      const removedMarketingType = await PromotionSettingsService.deleteResultType(result_type_id)
    }
  },

  async [types.CustomFileds.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("GP",payload)
    let obj={}
    if(payload=="promotion")
    {
      obj={
        ...getters.promotionSettingsData,
        promotion_custom_fields: [
          {
            custom_field_id: generateNextId(getters.promotionSettingsData.promotion_custom_fields.map(e => +e.custom_field_id)),
            field_label: '',
          },
          ...getters.promotionSettingsData.promotion_custom_fields,
        ]
      }
    }
    else
    {
        obj={
          ...getters.promotionSettingsData,
          result_custom_fields: [
          {
            custom_field_id: generateNextId(getters.promotionSettingsData.result_custom_fields.map(e => +e.custom_field_id)),
            field_label: '',
          },
          ...getters.promotionSettingsData.result_custom_fields,
        ]
        }
    }

    commit(types.PromotionSettingsData.SET.ALL,obj );
  },

  async [types.CustomFileds.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("WWWWWWWWWWWWWWWWWWWWW",payload)
    const { name, value, item } = payload.data;
    const { custom_field_id } = item;
    
    let obj={}
    if (isNegative(item.custom_field_id)) {

      const insertedField = await  PromotionSettingsService.insertCustomField(payload.ext_table,value)
      console.log("WWWWWWWWWWW",insertedField)
      const new_result_type_id = insertedField.data.custom_field_id;
    
      if(payload.ext_table=="promotion"){
        obj={
          ...getters.promotionSettingsData,
          promotion_custom_fields: getters.promotionSettingsData.promotion_custom_fields.map(m => {
            if (m.custom_field_id == custom_field_id) {
              return {
                ...m,
                custom_field_id: new_result_type_id,
                field_label: value,
              };
            } else {
              return m;
            }
          })
        }
      }
      else
      {
        console.log("UP",obj)
        obj={
          ...getters.promotionSettingsData,
          result_custom_fields: getters.promotionSettingsData.result_custom_fields.map(m => {
            if (m.custom_field_id == custom_field_id) {
              return {
                ...m,
                custom_field_id: new_result_type_id,
                field_label: value,
              };
            } else {
              return m;
            }
          })
        }
      }

        console.log("OBJS",obj)
      commit(types.PromotionSettingsData.SET.ALL, obj);
    } 
    else {
      if(payload.ext_table=="promotion")
      {
        obj={
          
            ...getters.promotionSettingsData,
            promotion_custom_fields: getters.promotionSettingsData.promotion_custom_fields.map(m => {
              if (m.custom_field_id == custom_field_id) {
                return {
                  ...m,
                  field_label: value,
                };
              } else {
                return m;
              }
            })
          
        }
      }
      else
      {
        obj={
          
          ...getters.promotionSettingsData,
          result_custom_fields: getters.promotionSettingsData.result_custom_fields.map(m => {
            if (m.custom_field_id == custom_field_id) {
              return {
                ...m,
                field_label: value,
              };
            } else {
              return m;
            }
          })
        
      }
      }
      
      
      
      commit(types.PromotionSettingsData.SET.ALL, obj);
      const updatedResultType = await PromotionSettingsService.updateCustomField(custom_field_id,value)
    }
  },


  async [types.CustomFileds.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log("DATA PAY",payload)
    // const { item } = payload.data;
    // const { custom_field_id } = item;
    // console.log("DATA PAY",item)
    let obj={}

    if(payload.ext_table=="promotion"){
     obj={ 
          ...getters.promotionSettingsData,
          promotion_custom_fields: getters.promotionSettingsData.promotion_custom_fields.filter(m => {
          return m.custom_field_id != payload.data.custom_field_id
        })
      }
    }
    else{
      obj={
        ...getters.promotionSettingsData,
        result_custom_fields: getters.promotionSettingsData.result_custom_fields.filter(m => {
        return m.custom_field_id != payload.data.custom_field_id
      })
      }
    }

    console.log("WWWWWWWWWW",obj)
    commit(types.PromotionSettingsData.SET.ALL,obj);
    
    if (!isNegative((payload.data.custom_field_id))) {
      console.log("DWLETE",payload.data.custom_field_id)
      const removedMarketingType = await PromotionSettingsService.deleteCustomField(payload.data.custom_field_id)
    }
  },
  async [types.Category.INSERT.SINGLE]({commit,getters,dispatch} ,payload){


    const categoriesRes= await PromotionSettingsService.insertCategory(payload.CategoryId,payload.CategoryName,payload.SubCategoryStrings,'add')


    let obj={ 
      ...getters.promotionSettingsData,
      categories: categoriesRes.data.categories
    }

    commit(types.PromotionSettingsData.SET.ALL,obj);
  },


  async [types.Category.UPDATE.SINGLE]({commit,getters,dispatch} ,payload){

    const updatedCategory=await PromotionSettingsService.updateCategories(payload.CategoryId,payload.CategoryName)
    const categoriesRes= await PromotionSettingsService.insertCategory(payload.CategoryId,payload.CategoryName,payload.SubCategoryStrings,'edit')
    

    let obj={ 
      ...getters.promotionSettingsData,
      categories: categoriesRes.data.categories
    }

    commit(types.PromotionSettingsData.SET.ALL,obj);
  },

  async [types.Category.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {

  
    const removedMarketingType = await PromotionSettingsService.deleteCategory(payload.category_id)
    commit(types.PromotionSettingsData.SET.ALL, {
      ...getters.promotionSettingsData,
      categories: getters.promotionSettingsData.categories.filter(m => {
        return m.category_id != payload.category_id
      })
    });
    
  
      

  },

  async [types.MediaType.INSERT.SINGLE]({commit,getters,dispatch} ,payload){


    const mediaRes= await PromotionSettingsService.insertMedia(payload.MediaId,payload.MediaName,payload.SubCategoryStrings,'add')


    let obj={ 
      ...getters.promotionSettingsData,
      media_types: mediaRes.data.media_types
    }

    commit(types.PromotionSettingsData.SET.ALL,obj);
  },

  async [types.MediaType.UPDATE.SINGLE]({commit,getters,dispatch} ,payload){

    const updatedMedia=await PromotionSettingsService.updateMedia(payload.MediaId,payload.MediaName)
    const mediaRes= await PromotionSettingsService.insertMedia(payload.MediaId,payload.MediaName,payload.SubCategoryStrings,'edit')
    

    let obj={ 
      ...getters.promotionSettingsData,
      media_types: mediaRes.data.media_types
    }

    commit(types.PromotionSettingsData.SET.ALL,obj);
  },

  async [types.MediaType.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {

  
    const removedMarketingType = await PromotionSettingsService.deleteMedia(payload.media_type_id)
    commit(types.PromotionSettingsData.SET.ALL, {
      ...getters.promotionSettingsData,
      media_types: getters.promotionSettingsData.media_types.filter(m => {
        return m.media_type_id != payload.media_type_id
      })
    });
    
  
      

  },

}
